document.addEventListener("DOMContentLoaded", function () {

  const faq_item = document.querySelectorAll(".faq-right .faq-item");

  if (faq_item.length > 0){
    const firs_item = faq_item[0];
    const first_faqQus = firs_item.querySelector('.faq-question');
    const first_faqAns = firs_item.querySelector('.faq-answer');

    if (first_faqQus && first_faqAns) {
      firs_item.classList.add('open');
      first_faqQus.classList.add('active');
      first_faqAns.style.height = first_faqAns.scrollHeight + 'px';
    }
  }
  
  faq_item.forEach((item) =>{
    const faq_qus = item.querySelector(".faq-question");
    const faq_ans = item.querySelector(".faq-answer");

    if (faq_qus && faq_ans){
      faq_qus.addEventListener("click", function(){
        const isOpen = item.classList.contains("open");

        faq_item.forEach( i => {
          const qus = i.querySelector(".faq-question");
          const ans = i.querySelector(".faq-answer");

          if (qus && ans){
            i.classList.remove("open");
            qus.classList.remove("active");
            ans.style.height = '0';
          }
        });
      
        if(!isOpen){
          item.classList.add("open");
          faq_qus.classList.add("active");
          faq_ans.style.height = faq_ans.scrollHeight + "px";
        }
      });
    }
  });

});